import { keysToCamel } from "utils/convertToCamel";

export const wrapResponse = (data, req) => {
	const keysToCamelData = keysToCamel(data);
	return {
		response: keysToCamelData,
		req
	};
};
